import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from 'src/app/_services/AuthService.service';
import { AdminServiceService } from 'src/app/_services/AdminService.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  loggedIn = false;
  apis;

  constructor(private _authService: AuthServiceService, private _adminService: AdminServiceService) { }

  ngOnInit() {
    this._authService.currentAction.subscribe(action => {
      this.loggedIn = this._authService.loggedIn();

      if (this.loggedIn) {
        this.loadApis();    
      }
    });
  
  }

  private loadApis() {
    this._adminService.getAPIsList().subscribe(data => {
      this.apis = data;
    });
  }


}
